
export const prefixPath = (path: string): string => {
  const currentPrefix = path.split('/')[1];
  return currentPrefix
}